import React from 'react';
import PropTypes from 'prop-types';

const PcComponentIcon = ({ type }) => {
  const common = {
    fill: 'none',
    height: 24,
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: 1.8,
    viewBox: '0 0 24 24',
    width: 24,
  };

  if (type === 'processor') {
    return <svg {...common}><rect x="6" y="6" width="12" height="12" rx="1" /><rect x="9" y="9" width="6" height="6" rx=".5" /><path d="M9 2v4m3-4v4m3-4v4M9 18v4m3-4v4m3-4v4M2 9h4m-4 3h4m-4 3h4m12-6h4m-4 3h4m-4 3h4" /></svg>;
  }
  if (type === 'memory') {
    return <svg {...common}><rect x="3" y="7" width="18" height="10" rx="1" /><path d="M6 10h2m2 0h2m2 0h2M6 14h2m2 0h2m2 0h2M6 17v2m3-2v2m3-2v2m3-2v2m3-2v2" /></svg>;
  }
  if (type === 'video') {
    return <svg {...common}><rect x="3" y="6" width="15" height="12" rx="1" /><circle cx="10.5" cy="12" r="3" /><path d="M18 10h3v4h-3M6 18v2m4-2v2" /></svg>;
  }
  if (type === 'motherboard') {
    return <svg {...common}><rect x="4" y="3" width="16" height="18" rx="1" /><rect x="7" y="6" width="6" height="6" /><path d="M16 6h1m-1 3h1m-1 3h1M7 16h10m-7-4v4" /></svg>;
  }
  if (type === 'storage') {
    return <svg {...common}><rect x="3" y="6" width="18" height="12" rx="2" /><circle cx="8" cy="12" r="2" /><path d="M14 10h4m-4 4h4" /></svg>;
  }
  if (type === 'case') {
    return <svg {...common}><rect x="6" y="2.5" width="12" height="19" rx="1" /><circle cx="12" cy="7" r="2" /><path d="M9 13h6m-6 3h6m-6 3h6" /></svg>;
  }
  if (type === 'power') {
    return <svg {...common}><path d="M8 3v6m8-6v6M6 9h12v4a6 6 0 0 1-12 0V9Z" /><path d="M12 15v6" /></svg>;
  }
  if (type === 'cooler') {
    return <svg {...common}><circle cx="12" cy="12" r="2" /><path d="M12 10c-3-4-1-6 1-7 2 3 2 6-1 7Zm2 2c4-3 6-1 7 1-3 2-6 2-7-1Zm-2 2c3 4 1 6-1 7-2-3-2-6 1-7Zm-2-2c-4 3-6 1-7-1 3-2 6-2 7 1Z" /></svg>;
  }
  return <svg {...common}><path d="M7 9V7a3 3 0 0 1 6 0v2m2 0V7a3 3 0 0 1 6 0v2" /><path d="M3 10h18v7H3zM7 14h.01m3 0h.01m4 0h.01m3 0h.01" /></svg>;
};

PcComponentIcon.propTypes = {
  type: PropTypes.string.isRequired,
};

export default PcComponentIcon;
